import { Resource } from "../models/resource/resource";
import { GTMService } from "./gtm.service";
import * as i0 from "@angular/core";
import * as i1 from "./gtm.service";
var PendoService = /** @class */ (function () {
    function PendoService(gtmService) {
        this.gtmService = gtmService;
        this.initialized = false;
    }
    PendoService.prototype.initialize = function () {
        var _this = this;
        if (this.initialized) {
            return;
        }
        this.initialized = true;
        this.gtmService.subscribe(function (data) { return _this.newData(data); });
    };
    PendoService.prototype.newData = function (pageData) {
        var _gtmTags = pageData.tags, resource = pageData.resource;
        // Multiple non page view events may come like this.
        if (resource &&
            window.pendo &&
            window.pendo.track &&
            resource instanceof Resource) {
            // pendo doesn't like nulls; falling back on empty string *just* in case something breaks here
            window.pendo.track("resource", {
                resourceCode: resource.resourceCode || "",
                resourceTitle: resource.title || "",
                resourceSubject: resource.getRootSubjectsValue()
                    ? resource.getRootSubjectsValue().join(",")
                    : "",
                resourceGrades: resource.gradeRanges || "",
            });
        }
    };
    PendoService.ngInjectableDef = i0.defineInjectable({ factory: function PendoService_Factory() { return new PendoService(i0.inject(i1.GTMService)); }, token: PendoService, providedIn: "root" });
    return PendoService;
}());
export { PendoService };
